import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav2").addClass("active");
